import type { ApprovalActionRecord } from '@/types/approvals';

interface Props {
  actions: ApprovalActionRecord[];
}

const ACTION_COLORS: Record<string, string> = {
  APPROVE: 'bg-emerald-500',
  REJECT: 'bg-red-500',
  RETURN: 'bg-amber-500',
  REQUEST_CHANGES: 'bg-amber-500',
  DELEGATE: 'bg-blue-500',
  ESCALATE: 'bg-orange-500',
  SUBMIT: 'bg-slate-500',
  COMMENT: 'bg-slate-400',
};

export function ApprovalTimeline({ actions }: Props) {
  if (!actions.length) {
    return <p className="text-sm text-slate-500">No actions recorded yet.</p>;
  }

  return (
    <ol className="relative space-y-4 border-l border-slate-200 pl-4 dark:border-slate-700">
      {actions.map((action) => (
        <li key={action.id} className="relative">
          <span
            className={`absolute -left-[1.35rem] top-1 h-2.5 w-2.5 rounded-full ring-2 ring-white dark:ring-slate-900 ${
              ACTION_COLORS[action.action] ?? 'bg-slate-400'
            }`}
          />
          <div className="rounded-lg border border-slate-200 bg-white p-3 dark:border-slate-700 dark:bg-slate-800/50">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <span className="text-sm font-medium text-slate-900 dark:text-slate-100">
                {action.action}
                {action.stepName ? ` · ${action.stepName}` : ''}
              </span>
              <time className="text-xs text-slate-500">
                {action.actedAt ? new Date(action.actedAt).toLocaleString() : ''}
              </time>
            </div>
            {action.comments ? (
              <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">{action.comments}</p>
            ) : null}
            {action.actorUserId ? (
              <p className="mt-1 text-xs text-slate-500">User #{action.actorUserId}</p>
            ) : null}
          </div>
        </li>
      ))}
    </ol>
  );
}
